$(function () {
    $('#js-newsletter-form').on('submit', function (e) {
        e.preventDefault();

        var form = $(this);

        grecaptcha.ready(function() {
            grecaptcha.execute(RECPATCHA_SITE_KEY, {action: 'newsletter'}).then(function(token) {
                // Add the token to the form
                document.querySelector('#g-recaptcha-newsletter').value = token;

                $.ajax({
                    url: form.attr('action'),
                    method: 'POST',
                    data: form.serialize(),
                    dataType: 'json',
                    timeout: 5000
                }).done(function (data) {
                    $('#js-newsletter-input').slideUp('medium', function () {
                        $('#js-newsletter-response').text(data.message);
                    });
                }).fail(function (xhr, status, error) {
                    $('#js-newsletter-response').text(xhr.responseJSON.errors);
                })
            });
        });
    });
})